import React, { Component } from "react";
import ReactToPrint from "react-to-print";
import { MDBDataTable } from "mdbreact";
import FeatherIcon from "feather-icons-react";
import UserIdentity from "./users/UserIdentity";
import Headerpdf from "./users/Headerpdf";
import "./Listprint.css";

class Listprint extends Component {
    componentRef = null;

    getPrintableColumns = () => {
        const { columns = [] } = this.props;
        return columns.filter((column) => column.printable !== false);
    };

    getDocumentTitle = () => {
        const title = this.props.title || "Liste";
        return title.replace(/[\\/:*?"<>|]/g, "-");
    };

    renderPrintTable = (columns, rows) => (
        <table className="list-print__table">
            <colgroup>
                {columns.map((column, index) => (
                    <col key={column.field || index} style={column.width ? { width: column.width } : undefined} />
                ))}
            </colgroup>
            <thead>
                <tr>
                    {columns.map((column, index) => (
                        <th key={column.field || index} scope="col">{column.label}</th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {rows.map((row, rowIndex) => (
                    <tr key={row.id || row.key || rowIndex}>
                        {columns.map((column, columnIndex) => (
                            <td key={`${column.field || columnIndex}-${rowIndex}`}>
                                {row[column.field] ?? ""}
                            </td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    );

    render() {
        const { columns = [], rows = [], matricule, name, classe, title } = this.props;
        const printableColumns = this.getPrintableColumns();
        const pageOrientation = printableColumns.length > 6 ? "landscape" : "portrait";

        return (
            <section className="list-print" aria-label={title || "Liste imprimable"}>
                <div className="list-print__toolbar">
                    <span className="list-print__count">
                        {rows.length} {rows.length > 1 ? "éléments" : "élément"}
                    </span>
                    <ReactToPrint
                        trigger={() => (
                            <button className="btn btn-sm btn-primary list-print__button" type="button">
                                <FeatherIcon icon="printer" size="17" />
                                <span>Imprimer</span>
                            </button>
                        )}
                        content={() => this.componentRef}
                        documentTitle={this.getDocumentTitle()}
                        pageStyle={`@page { size: A4 ${pageOrientation}; margin: 12mm; }`}
                    />
                </div>

                <div className="list-print__document" ref={(element) => { this.componentRef = element; }}>
                    <Headerpdf />
                    <UserIdentity matricule={matricule} name={name} classe={classe} title={title} />

                    <div className="list-print__interactive">
                        <MDBDataTable
                            entries={100}
                            entriesOptions={[10, 25, 50, 100, 200]}
                            className="size-10"
                            paging
                            striped
                            bordered
                            small
                            responsive
                            data={{ columns, rows }}
                        />
                    </div>

                    <div className="list-print__paper-table">
                        {this.renderPrintTable(printableColumns, rows)}
                    </div>
                </div>
            </section>
        );
    }
}

export default Listprint;
